import { random, round2 } from "../helpers/helpers";

export const generate_busbar_year_chart_demo = ({ year }) => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    const monthly_energy_data = [];

    for (let month = 1; month <= 12; month++) {
        // ❌ future months
        if (year === currentYear && month > currentMonth) break;

        monthly_energy_data.push({
            month,
            avg_temp_b: round2(random(24.5, 26.2)).toFixed(2),
            avg_temp_r: round2(random(24.2, 25.9)).toFixed(2),
            avg_temp_y: round2(random(24.2, 25.8)).toFixed(2),

            max_temp_b: round2(random(26.5, 29.8)).toFixed(2),
            max_temp_r: round2(random(26.2, 29.4)).toFixed(2),
            max_temp_y: round2(random(26.2, 29.3)).toFixed(2),

            min_temp_b: round2(random(23.5, 24.8)).toFixed(2),
            min_temp_r: round2(random(23.2, 24.6)).toFixed(2),
            min_temp_y: round2(random(23.2, 24.6)).toFixed(2),
        });
    }

    return {
        year,
        monthly_energy_data,
    };
};